import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'uriComponent',
    standalone: false,
})
export class UriComponentPipe implements PipeTransform {
    transform(value: string): string {
        return encodeURIComponent(value);
    }
}
